export default __webpack_public_path__ + "static/grid-aside-do-a9107e5b7eace679e4d0b13ec494197d4f564890696a3b3248d340e4cc31f7e3.png";